import useProductQuery from '@hooks/product/use-product-query';
import useProductShippingQuery from '@hooks/product/use-product-shipping-query';

const usePdpLayout = () => {
  const { product, userTransactionRole } = useProductQuery();
  const { productShipping } = useProductShippingQuery();
  const isSeller: boolean = userTransactionRole === 'seller';

  return {
    isRecirculation: !isSeller && (product?.sold || product?.seller?.vacation?.active || productShipping?.prohibited),
  };
};

export default usePdpLayout;
